import React, { useState } from 'react';
import { BlogCard } from './../../molecules/BlogCards/BlogCard';
import { blogCardData } from './../../../localData/blogCardData';
import {
  BlogSectionWrapper,
  NavigationButton,
  NavigationContainer,
  CardsContainer,
} from './BlogSection.Styles';
import { useIsDesktopOrLaptop, 
  useIsMiniNotebook, 
  useIsMobileBig, 
  useIsMobileMedium, 
  useIsMobileMini 
  } from '../../../styles/theme'


interface BlogSectionProps {
  tag: string;
}

export const BlogSection: React.FC<BlogSectionProps> = ({ tag }) => {
  const breakpoints = {
    isDesktopOrLaptop: useIsDesktopOrLaptop(),
    isMiniNotebook: useIsMiniNotebook(),
    isMobileBig: useIsMobileBig(),
    isMobileMedium: useIsMobileMedium(),
    isMobileMini: useIsMobileMini(),
  };

  const [currentPage, setCurrentPage] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false); // Estado para gerenciar a transição
  const itemsPerPage = 1;

  const filteredPosts = blogCardData.filter((post) =>
    !tag || post.tags?.includes(tag)
  );

  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const currentPosts = filteredPosts.slice(startIndex, endIndex);

  const handleNavigation = (direction: 'previous' | 'next') => {
    setIsTransitioning(true); 
    setTimeout(() => {
      setCurrentPage((prevPage) => {
        if (direction === 'previous' && prevPage > 0) return prevPage - 1;
        if (direction === 'next' && endIndex < filteredPosts.length) return prevPage + 1;
        return prevPage;
      });
      setIsTransitioning(false);
    }, 300);
  };

  const hasPrevious = currentPage > 0;
  const hasNext = endIndex < filteredPosts.length;

  return (
    <BlogSectionWrapper 
      isMobileMini={useIsMobileMini()}
      isMobileMedium={useIsMobileMedium()}
      isMobileBig={useIsMobileBig()}
      isMiniNotebook={useIsMiniNotebook()}>
      {/* Navegação no topo */}
      <NavigationContainer>
        <NavigationButton 
          onClick={() => handleNavigation('next')} 
          disabled={!hasNext}
          isMobileMini={useIsMobileMini()}
          isMobileMedium={useIsMobileMedium()}
          isMobileBig={useIsMobileBig()}
          isMiniNotebook={useIsMiniNotebook()}
          >
          Postagens Anteriores
        </NavigationButton>
        <NavigationButton 
          onClick={() => handleNavigation('previous')} 
          disabled={!hasPrevious}
          isMobileMini={useIsMobileMini()}
          isMobileMedium={useIsMobileMedium()}
          isMobileBig={useIsMobileBig()}
          isMiniNotebook={useIsMiniNotebook()}
        >
          Próximas Postagens
        </NavigationButton>
      </NavigationContainer>

      {/* Renderizar os cards com transição */}
      <CardsContainer 
        className={isTransitioning ? 'transitioning' : ''}
        isMobileMini={useIsMobileMini()}
        isMobileMedium={useIsMobileMedium()}
        isMobileBig={useIsMobileBig()}
        isMiniNotebook={useIsMiniNotebook()}
        >
      {currentPosts.map((post, index) => (
        <BlogCard
        key={index}
        post={{
          date: post.date,
          routeCard: post.routeCard,
          description: post.description,
          elements: post.elements,
          }}
        />
        ))}
      </CardsContainer>      
      <NavigationContainer>
        <NavigationButton 
          onClick={() => handleNavigation('next')}
          disabled={!hasNext}
          isMobileMini={useIsMobileMini()}
          isMobileMedium={useIsMobileMedium()}
          isMobileBig={useIsMobileBig()}
          isMiniNotebook={useIsMiniNotebook()}
          >
          Postagens Anteriores
        </NavigationButton>
        <NavigationButton 
        onClick={() => handleNavigation('previous')} 
        disabled={!hasPrevious}
        isMobileMini={useIsMobileMini()}
        isMobileMedium={useIsMobileMedium()}
        isMobileBig={useIsMobileBig()}
        isMiniNotebook={useIsMiniNotebook()}
        >
          Próximas Postagens
        </NavigationButton>
      </NavigationContainer>
    </BlogSectionWrapper>
  );
};

